import './App.css';
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion'
import NavigationRoutes from './routes';
// import ErrorHandler from './components/ErrorBoundary';
import awsConfig from './config/aws-export';
import { Amplify, Auth, Hub } from 'aws-amplify';
import GlobalContext from './components/Context/GlobalContext';
import Toast from './components/Toast';
Amplify.configure(awsConfig);
import 'react-tooltip/dist/react-tooltip.css'
import { useIdleTimer } from 'react-idle-timer';
import moment from 'moment'
import ErrorToast from './components/Toast/ErroToast';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from './pages/auth/authSlice';
// import { rumStage } from './config/index'
// import { rumStage } from './config/index'
import { AwsRum } from 'aws-rum-web';
if (awsConfig.Environment.stage === 'prod') {
    try {
        const config = {
            sessionSampleRate: 1 ,
            identityPoolId: "eu-central-1:f1a577cb-f51e-4a52-b4af-8dc55eedd607" ,
            endpoint: "https://dataplane.rum.eu-central-1.amazonaws.com" ,
            telemetries: ["performance","errors","http"] ,
            allowCookies: true ,
            enableXRay: false ,
            signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
        };

        const APPLICATION_ID = '1e203780-7c06-45a5-8231-e2469a3d46f2';
        const APPLICATION_VERSION = '1.0.0';
        const APPLICATION_REGION = 'eu-central-1';

        const awsRum = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );
    } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    }
}
/**
 * Main App component for admin web application
 * 
 * Handles global state, authentication, session management, and error handling.
 * Fixed missing dispatch import that was causing authentication errors during
 * token refresh and session expiration scenarios.
 * 
 * @param {Object} props - Component props
 */
function App(props) {
    const navigationPath = NavigationRoutes(props)
    const [Toastmessage, setToastmessage] = useState('');
    const [ToastErrorMessage, setToastErrorMessage] = useState('')
    const [sideBar, setSideBar] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch() // Required for logout action during auth token refresh
    const handleSignature = async () => {
        if (localStorage.getItem('user')) {
            if (localStorage.getItem('login_time')) {
                const storedDate = moment(localStorage.getItem('login_time'));
                const currentDate = moment();
                if (!currentDate.isSame(storedDate, 'day')) {
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/');
                    window.location.reload();
                }
            }
        }
    }
    const onIdle = () => {
        Auth.signOut()
        localStorage.clear();
        sessionStorage.clear();
        navigate('/');
        window.location.reload();
    };

    useIdleTimer({
        onIdle,
        timeout: 10800000,
        promptTimeout: 0,
        events: [
            'mousemove',
            'keydown',
            'wheel',
            'DOMMouseScroll',
            'mousewheel',
            'mousedown',
            'touchstart',
            'touchmove',
            'MSPointerDown',
            'MSPointerMove',
            'visibilitychange'
        ],
        immediateEvents: [],
        debounce: 0,
        throttle: 0,
        eventsThrottle: 200,
        element: document,
        startOnMount: true,
        startManually: false,
        stopOnIdle: false,
        crossTab: false,
        name: 'idle-timer',
        syncTimers: 0,
        leaderElection: false
    });

    useEffect(() => {
        handleSignature()
    }, []);
    useEffect(() => {
        Hub.listen('auth', async ({ payload }) => {
            switch (payload.event) {
            case 'tokenRefresh':
                try {
                    const userAttributes = await Auth.currentSession({ bypassCache: true });
                } catch (error) {
                    if (
                        ((error.message.includes('User needs to be authenticated')) ||
                                (error.name === 'UserUnAuthenticatedException') ||
                                (error.message.includes('Access Token has been revoked'))
                                || (error.name === 'NotAuthorizedException'))) {
                        if (localStorage.getItem('userLogedIn')) {
                            setToastError('user session failed!');
                        }
                        dispatch(logout());
                        localStorage.clear();
                        sessionStorage.clear();
                        navigate('/');
                    }
                }
            }
        });
    }, []);

    const [ToastError, setToastError] = useState('')
    return (
        <GlobalContext.Provider value={{
            setToastmessage,
            Toastmessage,
            ToastErrorMessage,
            setToastErrorMessage,
            setToastError,
            sideBar,
            setSideBar
        }}>
            <motion.div className='relative h-screen overflow-hidden'>
                {ToastError !== '' && <ErrorToast
                    message={ToastError}
                    type=""
                    setToastmessage={setToastError}
                />}
                {Toastmessage !== '' && <Toast
                    message={Toastmessage}
                    type="success"
                    setToastmessage={setToastmessage} />}
                {ToastErrorMessage !== '' && <Toast
                    message={ToastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
                {navigationPath}
            </motion.div>
        </GlobalContext.Provider>
    );
}

export default App;